module.exports = __webpack_public_path__ + "static/media/placeholder_6.568877e1.jpg";